<template>
    <b-button class="btn-reddit-login" @click="oauthReddit" v-if="!redditUser.length">
        Login with Reddit
    </b-button>
    <div v-else>
        <b-input-group prepend="u/">
        <b-form-input
            v-model="redditUser"
            trim
            :disabled="true"
            placeholder="Reddit username">
        </b-form-input>
        <b-button class="btn-reddit-logout" @click="logout" >
        Log Out
        </b-button>
        </b-input-group>
    </div>
</template>

<script>
import axios from 'axios';
import Crypto from 'crypto-js';
import Cookie from 'js-cookie';
import uuid from 'uuid';

const cookieName = 'RLCD-Cookie';
const storageKey = 'user-encrypted';

// Get the encryption token from cookie or generate a new one.
const encryptionToken = Cookie.get(cookieName) || uuid.v4();
Cookie.set(cookieName, encryptionToken, { secure: true, expires: 180 });

// Define reddit OAuth constants from https://www.reddit.com/prefs/apps/
// Localhost
// const clientId = 'bPEvi48F6F5uYzGsdTzlkg';
// const baseUrl = 'http://localhost:8080';

// Test
// const clientId = 'nkaW0V-D-Ra1yQ';
// const baseUrl = 'https://vikasbhatia.github.io/form';

// Beta
// const clientId = '8qHncOfXjwSku_cUyIs_SA';
// const baseUrl = 'https://rlcustomdesigns.github.io/form';

// Production
const clientId = 'lhkXgu4shMOxOg';
const baseUrl = 'https://rlcd.github.io/form';

export default {
    name: 'RedditOAuth',
    props: {
        redditUser: String
    },
    async created() {
        // var user = localStorage.user || '';
        var access_token = ''
        console.log("Getting user");
        var user = this.__getUser();
        this.$emit('update:redditUser', user);

        if (!user.length && location.toString().includes('code')) {

            var url_params = this.__getParamsFromURL(location.toString());
            console.log(`Auth code: ${url_params.code}`)
            console.log(`API state received: ${url_params.state}`)
            
            const rState = localStorage.getItem('rState');
            console.log(`Local state: ${rState}`)
            
            if (rState === url_params.state) {
                console.log('State matches. Sending access token request...')
                // Construct form params
                const params = new URLSearchParams();
                params.append('grant_type', 'authorization_code');
                params.append('code', url_params.code);
                params.append('redirect_uri', baseUrl);

                const axiosConfig = {
                    headers : {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    "Authorization": `Basic ${Buffer.from(`${clientId}:`).toString("base64")}`
                    }
                }
                // Send the request for an access token and await the response
                const access_token_response = await axios.post('https://www.reddit.com/api/v1/access_token', params, axiosConfig)
                
                access_token = access_token_response.data.access_token;

                if (access_token) {
                    console.log(`Received access token: ${access_token}`)
                    // this.removeUrlParams(); // only relevant if using the router, to be removed or reinstated later
                    
                    // send the request for the user identity. await the response
                    const me_response = await axios.get('https://oauth.reddit.com/api/v1/me', {
                        headers: {
                            Authorization: `Bearer ${access_token}`
                        }});
                    user = me_response.data.name;
                    console.log("Setting user");
                    this.__setUser(user);
                    // localStorage.setItem('user', user);
                    this.$emit('update:redditUser', user);
                    // this.removeUrlParams(); // only relevant if using the router, to be removed or reinstated later
                    window.history.pushState({}, document.title, baseUrl);
                    localStorage.removeItem('rState');
                } else {
                    console.log('Failed to get access token. Try again.')
                }
            }
        }
    },
    methods: {
        __parseRoute(route) {
            route = route.slice(1); // Remove leading /
            const params = {};
            const ps = route.split('&');
            for (const p of ps) {
                const [key, value] = p.split('=');
                params[key] = value
            }
            return params;
        },
        __getParamsFromURL(url) {
            url = url.slice(0, -3).split('?')[1] // Drop the '#/_' part from the end and get the part after the ? in the URL
            console.log(`Split URL: ${url}`)
            const params = {};
            const ps = url.split('&');
            console.log(`Splitting params from URL: ${ps}`)
            for (const p of ps) {
                const [key, value] = p.split('=');
                params[key] = value
            }
            return params;
        },
        __setUser(user) {
            const store = Crypto.AES.encrypt(user, encryptionToken).toString();
            // Save the encrypted store in local storage.
            return localStorage.setItem(storageKey, store);
        },
        __getUser() {
            const store = localStorage.getItem(storageKey);
            if (store) {
                try {
                    // Decrypt the store retrieved from local storage
                    // using our encryption token stored in cookies.
                    const bytes = Crypto.AES.decrypt(store, encryptionToken);

                    return bytes.toString(Crypto.enc.Utf8);
                } catch (e) {
                    // The store will be reset if decryption fails.
                    localStorage.removeItem(storageKey);
                }
            }
            return "";
        },
        removeUrlParams() {
            console.log("removing params");
            let route = this.$route
            if (Object.keys(route.query).includes(this.query)) {
                this.queryPush = {...route.query}
                delete this.queryPush[this.query]
                this.$router.push({ path: '/', query: this.queryPush })
            }else{
                    this.queryPush = {[this.query] : this.value }
                this.$router.push({ path: '/', query:  this.queryPush })
            }
        },
        __generateSecurityString(length = 20) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        oauthReddit() {
            const state = this.__generateSecurityString();
            localStorage.setItem('rState', state);
            const url = `https://old.reddit.com/api/v1/authorize?client_id=${clientId}&response_type=code&state=${state}&redirect_uri=${baseUrl}&duration=temporary&scope=identity`; // Use old.reddit.com to fix the no-redirection issue. See https://redd.it/cqu3hg
            location.replace(url);
        },
        logout() {
            localStorage.removeItem(storageKey);
            this.$emit('update:redditUser', '');
        }
    }
}
</script>